import { Grid } from "@mui/material";
import { RatecardClientInvoiceResponse } from "../../../../app/models/responseModels/ClientInvoiceResponses";
import SubmitModalWithFormik from "../../../../components/common/modalPopup/SubmitModalWithFormik";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  DatePicker as MuiDatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import Loader from "../../../../components/common/loader/Loader";
import { ClientInvoiceAgent } from "../../../../app/api/clientInvoices/ClientInvoiceAgent";
import { toast } from "react-toastify";
import getAxiosError from "../../../../app/api/axiosError";
import { updateUserTokenToInvalid } from "../../../../app/features/login/loginSlice";
import { useAppDispatch } from "../../../../app/features/store/store";
import { ClientInvoiceUIResponse } from "../../../../app/models/ApiResponse";
import { RatecardFdpInvoiceResponse } from "../../../../app/models/responseModels/FdpInvoiceResponses";

interface Props {
  invoice: RatecardFdpInvoiceResponse | undefined;
  closeSubmitInvoiceModal: CallableFunction;
}

interface InvoiceSubmit {
  submitTimestamp: Dayjs;
}

const SubmitFdpInvoiceModal = (props: Props) => {
  const dispatch = useAppDispatch();

  const initialValues: InvoiceSubmit = {
    submitTimestamp: dayjs(),
  };

  const validationSchema = Yup.object().shape({
    submitTimestamp: Yup.date().required(),
  });

  //TODO: need disscussion for FDP Invoice submit part
  const handleSubmit = async (
    uiRequest: InvoiceSubmit,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    // try {
    //   if (props.invoice && props.invoice.id) {
    //     const response: ClientInvoiceUIResponse =
    //       await ClientInvoiceAgent.changeInvoiceStatus(
    //         props.invoice.id,
    //         "submit",
    //         uiRequest.submitTimestamp
    //       );
    //     if (!response.isSuccess) {
    //       toast.error(response.message, {
    //         toastId: "submitClientInvoice",
    //       });
    //     } else {
    //       toast.success("Client Invoice has been submitted successfully.");
    //     }
    //   }
    // } catch (error) {
    //   const appError = getAxiosError(error);
    //   if (appError.code === "400") {
    //     toast.error("Some error occured", {
    //       toastId: "submitClientInvoiceException",
    //     });
    //   } else {
    //     toast.error(appError.errorMessage, {
    //       toastId: "submitClientInvoiceException",
    //     });
    //   }
    // } finally {
    //   setSubmitting(false);
    //   props.closeSubmitInvoiceModal();
    // }
    // return true;
  };

  return (
    <>
      {/* <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values: InvoiceSubmit, { setSubmitting }) => {
          setSubmitting(true);
          handleSubmit(values, setSubmitting);
        }}
      >
        {({ values, setFieldValue, isSubmitting }) => {
          return (
            <SubmitModalWithFormik
              title="Submit client invoice"
              closeSubmitModal={props.closeSubmitInvoiceModal}
              childErrorMessage={""}
              allowSubmit={false}
              size="sm"
              isLoading={false}
              submitButtonName="Submit"
              closeModalAfterSubmit={false}
              allowSubmitWithoutTouch={true}
            >
              <Grid
                container
                rowSpacing={2}
                columnSpacing={2}
                alignItems={"center"}
              >
                <Loader isLoading={isSubmitting} />

                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MuiDatePicker
                      name="submitTimestamp"
                      label="Select submit date"
                      value={values.submitTimestamp}
                      disablePast
                      slotProps={{
                        actionBar: {
                          actions: ["clear"],
                        },
                        textField: {
                          fullWidth: true,
                          size: "small",
                          margin: "normal",
                        },
                      }}
                      views={["year", "month", "day"]}
                      onChange={(newValue: any) => {
                        if (newValue) {
                          setFieldValue(`submitTimestamp`, newValue);
                        }
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </SubmitModalWithFormik>
          );
        }}
      </Formik> */}
    </>
  );
};

export default SubmitFdpInvoiceModal;
